import React, { useEffect, useMemo, useRef } from 'react';
import { Excalidraw } from '@excalidraw/excalidraw';
import { Button } from 'reactstrap';
import '@excalidraw/excalidraw/index.css';
import {
    buildStoredExcalidrawScene,
    createEmptyExcalidrawScene,
    normalizeExcalidrawScene,
} from '../Shared/questionDiagramUtils';

export function DiagramEditor({ scene, onSceneChange }) {
    const normalizedInitialScene = useMemo(
        () => normalizeExcalidrawScene(scene) || createEmptyExcalidrawScene(),
        [scene]
    );
    const draftSceneRef = useRef(normalizedInitialScene);

    useEffect(() => {
        // Reset the staged scene only when the caller intentionally loads a different diagram.
        draftSceneRef.current = normalizedInitialScene;
    }, [normalizedInitialScene]);

    const handleChange = (elements, appState, files) => {
        // Keep the latest scene in a ref so Excalidraw changes do not trigger React re-renders on every pointer move.
        draftSceneRef.current = buildStoredExcalidrawScene({ elements, appState, files });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <div style={{ flex: 1, position: 'relative' }}>
                <Excalidraw
                    initialData={normalizedInitialScene}
                    onChange={handleChange}
                    style={{ position: 'absolute', inset: 0 }}
                />
            </div>
            <div
                style={{
                    padding: '8px',
                    borderTop: '1px solid #ddd',
                    textAlign: 'right',
                    background: 'var(--bg-subtle)',
                }}
            >
                <Button
                    color="primary"
                    onClick={() => {
                        onSceneChange?.(draftSceneRef.current || normalizedInitialScene);
                    }}
                >
                    Save
                </Button>
            </div>
        </div>
    );
}

export default DiagramEditor;
